import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoUtils from './convo-utils'
import fetchComments from './fetch-comments'
import setMeta from './set-meta'
import { IConvo, ConvoMeta } from '../../../model/convo'
import { IComment, Comment } from '../../../model/comment'
import convoStore from '../convo-store'
import feedStore from '@/store/feed/feed-store';

export default async function addComment (context: BareActionContext<ConvoState, RootState>, convo: IConvo) {
  if (convo.meta) {
    let comment: IComment = new Comment()
    comment.title = convo.meta.newCommentTitle
    comment.body = convo.meta.newCommentBody
    convoUtils.convoService.addComment(convo, comment, convo.meta.newCommentStatements).then((result: any) => {
      convoStore.commitResetCommentForm({ convo: convo })
      if (convo.meta) convo.meta.comments = []
      convoStore.commitSetConvo({convo: convo})
      feedStore.dispatchViewConvos()
      fetchComments(context, convo)
    })
  }

  return
}
